import { React } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '../../../components/text-field';
import FilterIcon from '../../../assets/icons/filter-icon';
import SearchIconVariant from '../../../assets/icons/search-icon-variant';
import ApplyFiltersModal from 'components/apply-filters-modal/apply-filters-modal';
import useFilterOptions from './filter-options-hooks';
import SelectOld from 'components/select/select.old';
import useCustomers from '../customers-hooks';
import AlphaSort from 'components/modals/alphasort';
import { useMatch } from 'react-router-dom';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';

export default function FilterOptions({
  variant,
  setSearchValue,
  searchValue,
  applyFilters,
  alphabetValue,
  setAlphabetValue,
  getRetailers,
  retailerPage,
  setRetailerPage,
  buyer,
  showBuyers,
  clearFilters,
  searchParams,
}) {
  const {
    //state to manage apply filter modal state
    showApplyFiltersModal,
    setShowApplyFiltersModal,

    //state to manage filter count
    filterCount,
    setFilterCount,
  } = useFilterOptions();

  const isRetailerPage = useMatch('/my-customer/retailers');

  return (
    <Stack spacing={1}>
      <Stack direction='row' justifyContent='space-between'>
        {buyer ? (
          <ApplyFiltersModal
            open={showApplyFiltersModal}
            setOpen={setShowApplyFiltersModal}
            filtersToEnable={{
              salesRep: true,
              priceGroup: true,
              paymentTerms: false,
              shippingMethod: false,
              sortBy: false,
              showRetailersAndBuyersWith: false,
              groups: false,
              currency: true,
              showBuyers: true,
            }}
            applyFilters={applyFilters}
          />
        ) : (
          <ApplyFiltersModal
            open={showApplyFiltersModal}
            setOpen={setShowApplyFiltersModal}
            filtersToEnable={{
              salesRep: true,
              priceGroup: true,
              paymentTerms: true,
              shippingMethod: true,
              sortBy: true,
              showRetailersAndBuyersWith: true,
              groups: true,
              currency: false,
              showBuyers: false,
            }}
            applyFilters={applyFilters}
          />
        )}
        <Stack direction='row' spacing={1} alignItems='end'>
          <TextField
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              if (alphabetValue !== '' && alphabetValue !== undefined) {
                setAlphabetValue('');
              }
            }}
            placeholder='Search'
            startAdornment={<SearchIconVariant />}
            sx={{
              width: '740px',
              paddingLeft: '10px',
            }}
          />
          {clearFilters ? (
            <Box>
              <Button
                variant='contained'
                onClick={clearFilters}
                color='error'
                size='small'
                fontStyle='bold'
                fontWeight='700'
                sx={{ cursor: 'pointer' }}
              >
                Clear Filters
              </Button>
            </Box>
          ) : null}
        </Stack>

        <Button
          size='small'
          variant='outlined'
          color={filterCount > 0 ? 'primary' : 'secondary'}
          startIcon={<FilterIcon />}
          onClick={(e) => {
            e.preventDefault();
            setShowApplyFiltersModal(!showApplyFiltersModal);
          }}
          sx={filterCount > 0 ? { backgroundColor: '#fff' } : null}
        >
          <Stack direction='row' spacing={1}>
            <Typography>Filters</Typography>
            {filterCount > 0 ? (
              <Typography
                sx={{
                  width: '20px',
                  height: '20px',
                  borderRadius: '50%',
                  backgroundColor: 'primary.main',
                  color: '#fff',
                }}
              >
                {filterCount}
              </Typography>
            ) : null}
          </Stack>
        </Button>
      </Stack>
      {isRetailerPage ? (
        <AlphaSort
          alphabetValue={alphabetValue}
          setAlphabetValue={(val) => {
            if (val !== '') setSearchValue('');
            if (alphabetValue !== val) setRetailerPage(1);
            setAlphabetValue(val);
            getRetailers({
              page: retailerPage,
              alphabetValue: val,
              searchTerm: searchParams.get('srch'),
              filters: searchParams.get('filters') ?? '',
            });
          }}
        />
      ) : null}
    </Stack>
  );
}

FilterOptions.propTypes = {
  variant: PropTypes.string,
  setSearchValue: PropTypes.func,
  searchValue: PropTypes.string,
  salesRep: PropTypes.array.isRequired,
  setSalesRep: PropTypes.func.isRequired,
  priceGroup: PropTypes.array.isRequired,
  setPriceGroup: PropTypes.func.isRequired,
  paymentTerms: PropTypes.array.isRequired,
  setPaymentTerms: PropTypes.func.isRequired,
  shippingMethod: PropTypes.array.isRequired,
  setShippingMethod: PropTypes.func.isRequired,
  sortBy: PropTypes.object.isRequired,
  setSortBy: PropTypes.func.isRequired,
  showRetailersAndBuyersWith: PropTypes.object.isRequired,
  setShowRetailersAndBuyersWith: PropTypes.func.isRequired,
  currency: PropTypes.array.isRequired,
  setCurrency: PropTypes.func.isRequired,
  groups: PropTypes.array.isRequired,
  setGroups: PropTypes.func.isRequired,
  showBuyers: PropTypes.object.isRequired,
  setShowBuyers: PropTypes.func.isRequired,
  applyFilters: PropTypes.func.isRequired,
  alphabetValue: PropTypes.string.isRequired,
  setAlphabetValue: PropTypes.func.isRequired,
  getRetailers: PropTypes.func.isRequired,
  retailerPage: PropTypes.string.isRequired,
  setRetailerPage: PropTypes.func.isRequired,
  buyer: PropTypes.bool,
  clearFilters: PropTypes.func,
  searchParams: PropTypes.object.isRequired,
};
FilterOptions.defaultProps = {
  variant: null,
  setSearchValue: null,
  searchValue: null,
  buyer: false,
};
